'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PrimaryCommentEditor = require('./components/PrimaryCommentEditor');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PrimaryCommentEditor).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/primary-comment-editor/index.js
// module id = 1526
// module chunks = 1